import { Snapshot } from "@/components/snapshot/Snapshot";
import { SnapshotContent } from "@/components/snapshot/SnapshotContent";
import { SnapshotHeader } from "@/components/snapshot/SnapshotHeader";
import { SnapshotPipeline } from "@/components/snapshot/SnapshotPipeline";
import { SnapshotSection } from "@/components/snapshot/SnapshotSection";
import { InventorySnapshotEstorePull } from "./InventorySnapshotEstorePull";

/**
 * The Inventory snapshots page: one section per 3PL stock report — Toll's SOH workbook (uploaded) and
 * eStore's (pulled from its SFTP). Building one also imports it into our inventory, from each
 * warehouse's newest file on or before the day.
 */
export const InventorySnapshot = () => {
  return (
    <Snapshot>
      <SnapshotHeader title="Inventory snapshots" />
      <SnapshotContent>
        <SnapshotPipeline />
        <SnapshotSection
          label="Toll stock"
          report="toll-inventory"
        />
        <SnapshotSection
          label="eStore stock"
          report="estore-inventory"
        >
          <InventorySnapshotEstorePull />
        </SnapshotSection>
      </SnapshotContent>
    </Snapshot>
  );
};
